<template>
 <div class="content-middle">
   <div class="cont-con clearfix">
            <div class="cont-left  hidden-xs">
                <div class="contl-header">
                    音频口超高频小精灵
                    <button class="menu-button" id="open-button">Open Menu</button>
                </div>
                <div class="menu-wrap">
                    <nav class="menu">
                        <div class="icon-list">
                            <router-link  :to="{path: list.url, query: {index: index}}"  :class="{'current': currentIndex == index}" v-for="(list, index) in lists" v-bind:key="index">{{list.text}}</router-link>
                        </div>
                    </nav>
                    <button class="close-button" id="close-button">Close Menu</button>
                </div>
            </div>
            <div class="cont-right">
                  <div class="contr-header clearfix">
                  <h4>{{runame}}</h4>
                    <div class="contr-nav">
                        <router-link to="/" >首页</router-link> &gt;
                        <router-link :to="{path:'/RU',query: {index: 0}}">音频口超高频小精灵</router-link> &gt; {{runame}}
                    </div>
                    </div>
                <router-view></router-view>
            </div>
        </div>
 </div>
</template>

<script>
 export default {
   mounted() {
     this.runame = this.$route.meta.title;
    this.currentIndex = this.$route.query.index;
  },
   data () {
     return {
       runame: "RU02",
       currentIndex: 0,
       lists: [{text:'RU02', url: '/RU/02'}, {text:'RU03',url:'/RU/03'}]
     }
   },
   methods: {
   },
   watch: {
     $route(to, from) {
       if(to!= undefined) {
         this.currentIndex = to.query.index
          this.runame = to.meta.title
       }
     }
   },
   components: {

   }
 }
</script>

<style lang="stylus" scoped rel="stylesheet/stylus">

 
</style>



// WEBPACK FOOTER //
// src/components/RU/RUindex.vue